import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, without, concat } from 'lodash';
import { Collapse } from 'react-bootstrap';
import { Field } from 'redux-form';
import Fa from 'react-fontawesome';
import masterField from '../../../../../components/search-form/master-field';
import renderField from './render-field';

const primaryContactOptions = [
  { value: 'roles-and-primary', label: 'By Primary Contact plus Role' },
  { value: 'roles-or-primary', label: 'By Primary Contact or Role' },
  { value: 'roles', label: 'By Role' },
  { value: 'primary', label: 'Primary Contact Only' },
];

class ContactRoleField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.toggleRole = this.toggleRole.bind(this);
  }

  toggleRole(option) {
    const { contactRoles } = this.props;
    const exists = indexOf(contactRoles, option) >= 0;
    const newOptions = exists ? without(contactRoles, option) : concat(contactRoles, option);
    // if (newOptions.length === 0) {
      // newOptions = map(allOptions, 'value');
    // }
    this.props.onRolesChange(newOptions);
  }

  render() {
    const { disabled, value, allRoles, contactRoles } = this.props;

    const displayRoles = value !== 'primary';
   

    return (
      <div>
        <Field
          name="full_automation_opportunty_contact_types"
          componentClass="select"
          options={primaryContactOptions}
          component={renderField}
          disabled={disabled}
          input={{
            value,
            onChange: (e) => {
              if (e.target.value) {
                this.props.onContactTypeChange(e.target.value);
              }
            },
          }}
        />

        <Collapse in={(displayRoles !== false)}>
          <div className="panel panel-default" style={{ marginTop: 10 }}>
            <div className="panel-heading">
              <div className="panel-title">
                With any of the Following Opportunity Contact Roles:
              </div>
            </div>
            <div className="panel-body">
              {allRoles.map((option) => {
                const active = indexOf(contactRoles, option.value) >= 0;
                const lbl = (option.value && option.label !== option.value) ? (<span>{option.label} (<code>{option.value}</code>)</span>) : option.label;
                const innerLabel = (
                  <span><Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> {lbl}</span>
                );
                const labelComp = option.value === null ? (<em>{innerLabel}</em>) : innerLabel;
                return (
                  <div key={option.value}>
                    <div
                      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                      key={option.value}
                      onClick={() => {
                        if (!disabled) {
                          this.toggleRole(option.value);
                        }
                      }}
                    >
                      {labelComp}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

ContactRoleField.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onContactTypeChange: PropTypes.func,
  onRolesChange: PropTypes.func,
  allRoles: PropTypes.arrayOf(PropTypes.shape({})),
  contactRoles: PropTypes.arrayOf(PropTypes.string),
};
ContactRoleField.defaultProps = {
  value: null,
  disabled: false,
  submitting: false,
  allRoles: [],
  contactRoles: [],
  onContactTypeChange: () => {},
  onRolesChange: () => {},
};
export default masterField(ContactRoleField);
